import React, { PureComponent, Children, cloneElement } from 'react';
import { withRouter } from 'react-router-dom';
import { ControlLeaderBoardsWrapper, InfoWrapper, ButtonWrapper, SeletedWrapperBox } from './style';
//ui
import { Button } from '../../UI/Button';
import { Text } from '../../UI/Text';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spinner } from '../../Components/Spiner/Spiner';
import './InfiniteScrollStyle.css';

class SelectionForLeaderBoards extends PureComponent {
    state = {
        selected: [],
        selectedLength: 0,
        LB_length: 0,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (
            nextProps.leaderboardsLength > prevState.LB_length ||
            (nextProps.leaderboardsLength < prevState.LB_length && prevState.LB_lengt !== 0)
        ) {
            const _updatedState = Object.assign({}, prevState);
            _updatedState['LB_length'] = nextProps.leaderboardsLength;

            return _updatedState;
        }

        return null;
    }

    selectLeaderBoards = boardId => {
        this.setState(prevState => {
            const _prevState = Object.assign({}, prevState);

            prevState.selected.includes(boardId)
                ? (_prevState['selected'] = _prevState.selected.filter(existingId => existingId !== boardId))
                : (_prevState['selected'] = _prevState.selected.concat(boardId));

            _prevState['selectedLength'] = _prevState['selected'].length;

            return _prevState;
        });
    };

    isSelected = selectedList => boardId => {
        return selectedList.includes(boardId);
    };

    providePropsForChildren = () => ({
        onSelect: this.selectLeaderBoards,
        isSelected: this.isSelected(this.state.selected),
    });

    renderChildrenWithProps = () => {
        return Children.map(this.props.children, child => {
            return cloneElement(child, this.providePropsForChildren());
        });
    };
    handleNavigate = event => {
        const { selectedLength } = this.state;
        if (selectedLength > 0) {
            this.props.history.replace(this.generatePathForLeaderBoardsCarusel());
        }
    };

    handleSelection = () => {
        const { selectedLength, selected } = this.state;
        const lbs = selected.map(item => {
            return { id: item };
        });
        if (selectedLength > 0)
            this.props.onLeaderboardsSelect(this.props.initialModalType, {
                // name: convertDisplayTypeNumberToName(this.props.selectLeaderboardType),
                // data: [...selected],
                // selectKey: this.props.selectLeaderboardType,
                type: this.props.initialModalType,
                content_type: this.props.selectLeaderboardType,
                leaderboards: { data: [...lbs] },
            });
    };

    generatePathForLeaderBoardsCarusel = () => {
        const search = `?id=${this.state.selected}`;
        if (this.props.match.params.workoutId) {
            return {
                pathname: `/${this.props.match.params.profileId}/workout/${
                    this.props.match.params.workoutId
                }/leaderboards/selected`,
                search,
            };
        } else {
            return {
                pathname: `/${this.props.match.params.profileId}/leaderboards/selected`,
                search,
            };
        }
    };

    render() {
        const { selectedLength } = this.state;
        const { loadMoreLeaderboards, moreLeaderboardsAvailable, onLeaderboardsSelect } = this.props;

        return this.state.LB_length !== 0 ? (
            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ margin: '10px' }}>
                    <ControlLeaderBoardsWrapper center={this.props.isCentered}>
                        <InfoWrapper>
                            <div>
                                <Text small opacity={'0.5'}>
                                    {this.state.LB_length} LEADERBOARDS
                                </Text>
                            </div>

                            <SeletedWrapperBox>
                                <Text weight={'bold'} uppercase small opacity={'0.5'}>
                                    {selectedLength} selected
                                </Text>
                            </SeletedWrapperBox>
                        </InfoWrapper>

                        <ButtonWrapper>
                            <Button
                                disabled={!selectedLength}
                                padding={'6px 14px'}
                                onClick={onLeaderboardsSelect ? this.handleSelection : this.handleNavigate}
                            >
                                <Text weight={'bold'} nowrap>
                                    {onLeaderboardsSelect ? 'SAVE SELECTION' : 'START GYM DISPLAY'}
                                </Text>
                            </Button>
                        </ButtonWrapper>
                    </ControlLeaderBoardsWrapper>
                </div>

                <InfiniteScroll
                    className="leaderboards-scroll"
                    dataLength={Array.from({ length: 16 })}
                    next={loadMoreLeaderboards}
                    hasMore={moreLeaderboardsAvailable}
                    loader={<Spinner />}
                >
                    {this.renderChildrenWithProps()}
                </InfiniteScroll>
            </div>
        ) : null;
    }
}

export default withRouter(SelectionForLeaderBoards);



// WEBPACK FOOTER //
// ./src/UI/Containers/SelectionForLeaderBoards/SelectionForLeaderBoards.js